import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class GuestGuard implements CanActivate {
  constructor(private router: Router) {

  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    if (localStorage.getItem('user') || localStorage.getItem('id_token')) {
      console.log('Estas logueado, no puedes entrar a esta página');
      this.router.navigate(['/admin','home']);
      return false;
    }
    else {
      return true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/guards/guest.guard.ts